import { SectionHeading, Subheading as SubheadingBase } from 'components/misc/Headings.js';
import EmailIllustrationSrc from 'images/email-illustration.svg';
import styled from 'styled-components';
import tw from 'twin.macro';

const Bold = tw.span`font-bold`;
const PrimaryText = tw.span`text-primary-500`;

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-10 lg:py-12`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto`;
const TextColumn = styled(Column)((props) => [
    tw`md:w-7/12 mt-16 md:mt-0`,
    props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`,
]);

const Image = styled.div((props) => [
    `background-image: url("${props.imageSrc}");`,
    tw`rounded bg-contain bg-no-repeat bg-center h-full`,
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(
    SectionHeading
)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-400`;

const Features = tw.div`mt-8 max-w-sm mx-auto md:mx-0`;
const Feature = tw.div`mt-3 flex items-start flex-col md:flex-row`;

const FeatureIconContainer = styled.div`
    ${tw`mx-auto md:mx-1 inline-block text-center py-1 flex-shrink-0`}
    svg {
        ${tw`w-5 h-5 text-primary-500`}
    }
`;
const FeatureText = tw.div`w-full mt-4 md:mt-0 md:ml-2 text-center md:text-left`;
const FeatureHeading = tw.div`font-bold text-lg text-primary-500`;

export default ({
    subheading = 'Kontaktirajte nas',
    heading = (
        <>
            Želite povećati prodaju kroz <PrimaryText>bolje podatke?</PrimaryText>
        </>
    ),
    description = (
        <>
            <Bold>Kontaktirajte nas – prvi korak je besplatan savet.</Bold> Za sva pitanja, sugestije ili komentare,
            slobodno nam se obratite na neki od načina ispod. Uvek smo tu da vam pomognemo i odgovorimo na vaša pitanja.
        </>
    ),
    features = null,
    textOnLeft = true,
}) => {
    // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.

    return (
        <Container>
            <TwoColumn>
                <ImageColumn>
                    <Image imageSrc={EmailIllustrationSrc} />
                </ImageColumn>
                <TextColumn textOnLeft={textOnLeft}>
                    <TextContent>
                        {subheading && <Subheading>{subheading}</Subheading>}
                        <Heading id="kontakt">{heading}</Heading>
                        <Description>{description}</Description>
                        <Features>
                            {features.map((feature, index) => (
                                <Feature key={index}>
                                    <FeatureIconContainer>{<feature.Icon />}</FeatureIconContainer>
                                    <FeatureText>
                                        <FeatureHeading>{feature.title}</FeatureHeading>
                                    </FeatureText>
                                </Feature>
                            ))}
                        </Features>
                    </TextContent>
                </TextColumn>
            </TwoColumn>
        </Container>
    );
};
